import { MetaData } from 'models/MetaData/metaData.model';
import * as yup from 'yup';

const idValidationSchema = (fieldName: string) =>
  yup.string().required(`${fieldName} is required`).nullable();

export const orgValidationSchema = (
  isMainParent?: boolean,
  organisationList?: MetaData[],
  isEdit?: boolean
) => {
  return yup.object().shape({
    name: yup
      .string()
      .required('Organization Name is required')
      .max(30, 'Organization Name must be at most 30 characters')
      .test(
        'unique-name',
        'Organization Name must be unique',
        function (value) {
          return !organisationList?.some(
            org => org?.name?.toLowerCase() === value?.toLowerCase()
          );
        }
      )
      .nullable(),

    size: yup.object().shape({
      id: idValidationSchema('Organization Size'),
    }),

    sector: yup.object().shape({
      id: idValidationSchema('Sector'),
    }),

    companyType: yup.object().shape({
      id: idValidationSchema('Company Type'),
    }),

    company: yup.object().shape({
      organizationalBoundary: yup.string().when([], {
        is: () => !!isMainParent && !isEdit,
        then: yup.string().required('Organizational Boundary is required'),
        otherwise: yup.string().notRequired(),
      }),
      recalculationThreshold: yup.number().when([], {
        is: () => !!isMainParent && !isEdit,
        then: yup
          .number()
          .required('Recalculation Threshold is required')
          .max(100, 'Recalculation Threshold must be less than or equal to 100')
          .min(0, 'Recalculation Threshold must be greater than or equal to 0')
          .nullable(),
        otherwise: yup.number().notRequired(),
      }),
    }),
    organisationYearWise: yup.object().shape({
      organizationShare: yup.string().when([], {
        is: () => !!isMainParent,
        then: yup.string().notRequired(),
        otherwise: yup
          .string()
          .required('Organization Boundary is required')
          .nullable()
          .max(100, 'Organization Share must be less than or equal to 100')
          .min(0, 'Organization Share must be greater than or equal to 0'),
      }),
    }),
  });
};

export const selectOrgValidationSchema = yup.object().shape({
  organisation: yup.string().required('Please select an organization'),
});

export const editOrganizationValidationSchema = (isMainParent?: boolean) => {
  return yup.object().shape({
    organization: orgValidationSchema(isMainParent, [], true).nullable(),
    company: yup.object().shape({
      organizationalBoundary: yup.string().when([], {
        is: () => !!isMainParent,
        then: yup.string().required('Organizational Boundary is required'),
        otherwise: yup.string().notRequired(),
      }),
      recalculationThreshold: yup
        .number()
        .required('Recalculation Threshold is required')
        .max(100, 'Recalculation Threshold must be less than or equal to 100')
        .min(0, 'Recalculation Threshold must be greater than or equal to 0'),
    }),
  });
};
